export class ThemeController {
    log;
    theme;
    userInterfaceClass;
    static $inject = ['$scope', 'LogService', 'ThemeService', 'SettingsService'];
    constructor($scope, logService, themeService, settingsService) {
        this.log = logService.getLogger('Theme-C', 'color: #000; background-color: #ffff99');
        this.theme = themeService.theme;
        themeService.evtThemeChange.attach((newTheme) => {
            this.log.debug(`Updating theme: ${this.theme} -> ${newTheme}`);
            $scope.$apply(() => this.theme = newTheme);
        });
        this.userInterfaceClass = ThemeController.getUserInterfaceClass(settingsService.userInterface.getUserInterface());
        settingsService.userInterfaceChange.attach((newUserInterface) => {
            const newUserInterfaceClass = ThemeController.getUserInterfaceClass(newUserInterface);
            this.log.debug(`Updating user interface class: ${this.userInterfaceClass} -> ${newUserInterfaceClass}`);
            $scope.$apply(() => this.userInterfaceClass = newUserInterfaceClass);
        });
    }
    static getUserInterfaceClass(userInterface) {
        const base = 'user-interface-';
        switch (userInterface) {
            case "minimal":
                return base + 'minimal';
            default:
                return base + 'default';
        }
    }
}
